var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.16989 1.16989 0.5 2 0.5H26C26.8301 0.5 27.5 1.16989 27.5 2C27.5 2.83011 26.8301 3.5 26 3.5H2C1.16989 3.5 0.5 2.83011 0.5 2ZM0.5 12C0.5 11.1699 1.16989 10.5 2 10.5H26C26.8301 10.5 27.5 11.1699 27.5 12C27.5 12.8301 26.8301 13.5 26 13.5H2C1.16989 13.5 0.5 12.8301 0.5 12ZM27.5 22C27.5 22.8301 26.8301 23.5 26 23.5H2C1.16989 23.5 0.5 22.8301 0.5 22C0.5 21.1699 1.16989 20.5 2 20.5H26C26.8301 20.5 27.5 21.1699 27.5 22Z",
    fill: "white",
    stroke: "#112B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.7d4e16736e854a1881a9458308a90bed.svg";
export { ForwardRef as ReactComponent };